export function notifyMe({ title, message }) {
  if (window.localStorage.getItem('_crm_avaya_system_notify') === '1') {
    // 看有没有关闭这个通知
    console.log('Notification.permission', Notification.permission)
    if (!('Notification' in window)) {
      // 检查浏览器是否支持通知
    } else if (Notification.permission === 'granted') {
      // 检查是否已授予通知权限；如果是的话，创建一个通知
      handleNotice({ title, message })
    } else if (Notification.permission !== 'denied') {
      // 我们需要征求用户的许可
      Notification.requestPermission().then(permission => {
        // 如果用户接受，我们就创建一个通知
        if (permission === 'granted') {
          handleNotice({ title, message })
        }
      })
    }
  }
}
let flag = false
export const handleNotice = ({ title, message }) => {
  console.log('handleNotice')
  // 简单防抖，至少30s不得多次提醒
  if (flag) return
  flag = true
  setTimeout(() => {
    flag = false
  }, 30 * 1000)
  const notification = new Notification(title, {
    body: message
  })
  notification.onclick = function() {
    notification.close()
    window.focus()
  }
}
